import {AppRoute} from "types";

import {
	Login,
	AcceptInvitation,
	ForgotPassword,
	ResetPassword,
	Register,
	VerifyEmail,
	Confirm2FA,
	BlockedRegister,
	Profile,
	NotFound,
	CandidateDetails,
	CompanyDetails,
	Error,
	ExtendedSearch,
	ExtendedSearchAiRuns,
	FlaggedCandidatesPage,
	Home,
	LearnToRank,
	MarketMap,
	Onboarding,
	Organisation,
	Organizations,
	CustomerUsagePage,
	AdminUsagePage,
	ProjectEntry,
	ProjectsV2,
	PolarisAnalytics,
	PolarisEntry,
	PolarisSearches,
	PolarisStrategy,
	CandidateSearch,
	CompanySearch,
	MarketReports,
	MarketReportDetails,
	MarketReportCreate,
} from "./routePages";
import {withPolarisAccess} from "mapx-pages/Polaris/withPolarisAccess";

const homePage = {
	path: ["/", "/home", "/home/watchDemo", "/home/:modal"],
	component: Home,
	exact: true,
	private: true,
};

const routes: (isShowOnBoarding: boolean) => AppRoute[] = (isShowOnBoarding: boolean) => {
	return [
		{
			path: "/login",
			pathname: "login",
			component: Login,
			exact: true,
		},
		{
			path: "/confirm-2fa",
			pathname: "confirm2fa",
			component: Confirm2FA,
			exact: true,
		},
		{
			path: "/forgot-password",
			component: ForgotPassword,
			exact: true,
		},
		{
			path: "/reset-password",
			component: ResetPassword,
			exact: true,
		},
		{
			path: "/accept-invitation",
			component: AcceptInvitation,
			exact: true,
		},
		{
			path: "/register/blocked",
			component: BlockedRegister,
			exact: true,
		},
		{
			path: "/register/verify-email",
			component: VerifyEmail,
			exact: true,
		},
		{
			path: "/register",
			component: Register,
			exact: true,
		},

		// Pages

		homePage,
		{
			path: "/profile",
			component: Profile,
			exact: true,
			private: true,
		},
		isShowOnBoarding
			? {
					path: ["/onboarding/home", "/onboarding/projects"],
					component: Onboarding,
					exact: true,
					private: true,
			  }
			: homePage,
		{
			path: "/projects",
			component: ProjectsV2,
			exact: true,
			private: true,
		},
		{
			path: [
				"/project/:id",
				"/project/:id/:candidateId",
				"/project/:id/candidate/:candidateId",
			],
			component: ProjectEntry,
			exact: true,
			private: true,
		},
		{
			path: ["/organisation-settings", "/organisation-settings/:modal"],
			component: Organisation,
			exact: true,
			private: true,
		},
		{
			path: ["/companies", "/market-maps"],
			component: CompanySearch,
			exact: true,
			private: true,
		},
		{
			path: "/market-reports/create",
			component: MarketReportCreate,
			exact: true,
			private: true,
		},
		{
			path: "/market-reports/edit/:id",
			component: MarketReportCreate,
			exact: true,
			private: true,
		},
		{
			path: "/market-reports/:id",
			component: MarketReportDetails,
			exact: true,
			private: true,
		},
		{
			path: "/market-reports",
			component: MarketReports,
			exact: true,
			private: true,
		},
		{
			path: [
				"/candidates-filter-search",
				"/candidates-filter-search/:candidateId",

				"/candidates-text-search",
				"/candidates-text-search/:candidateId",

				"/candidates-profile-search",
				"/candidates-profile-search/:candidateId",

				"/candidates-ai-web-search",
				"/candidates-ai-web-search/:candidateId",
			],
			component: CandidateSearch,
			exact: true,
			private: true,
		},
		{
			path: "/candidate/:id",
			component: CandidateDetails,
			exact: true,
			private: true,
		},
		{
			path: ["/company/:id", "/company/:id/:candidateId"],
			component: CompanyDetails,
			exact: true,
			private: true,
		},

		// {
		// path: "/market-maps",
		// component: MarketMaps,
		// exact: true,
		// private: true,
		// },

		{
			path: "/market-maps/:id/:token",
			component: MarketMap,
			exact: true,
			private: false,
		},
		{
			path: ["/organisations", "/organisations/invited"],
			component: Organizations,
			exact: true,
			private: true,
		},
		// Usage dashboard: customers see their own organisation, Savannah staff any of them.
		// Both pages guard themselves; the API also refuses anyone outside the organisation.
		{
			path: "/organisation-usage",
			component: CustomerUsagePage,
			exact: true,
			private: true,
		},
		{
			path: "/organisations/:id/usage",
			component: AdminUsagePage,
			exact: true,
			private: true,
		},
		{
			path: "/polaris",
			component: withPolarisAccess(PolarisEntry),
			exact: true,
			private: true,
		},
		{
			path: "/polaris/analytics",
			component: withPolarisAccess(PolarisAnalytics),
			exact: true,
			private: true,
		},
		{
			path: "/polaris/searches",
			component: withPolarisAccess(PolarisSearches),
			exact: true,
			private: true,
		},
		{
			path: [
				"/polaris/searches/:searchId",
				"/polaris/searches/:searchId/candidate/:candidateId",
			],
			component: withPolarisAccess(PolarisStrategy),
			exact: true,
			private: true,
		},
		{
			path: "/learn-to-rank",
			component: LearnToRank,
			exact: true,
			private: true,
		},
		// The real superuser gate is the in-component redirect on the page itself: PrivateRoute
		// only checks a `role` the API hardcodes identically for every user, so it always passes.
		{
			path: "/extended-search",
			component: ExtendedSearch,
			exact: true,
			private: true,
		},
		{
			path: ["/extended-search/ai-runs", "/extended-search/ai-runs/:aiRunId"],
			component: ExtendedSearchAiRuns,
			exact: true,
			private: true,
		},
		{
			path: ["/flagged-candidates", "/flagged-candidates/candidate/:candidateId"],
			component: FlaggedCandidatesPage,
			exact: true,
			private: true,
		},

		// Not found
		{
			path: ["/403", "/404", "/503", "/500", "/invitation-invalid", "/unknown-error"],
			component: Error,
			exact: true,
		},
		{
			path: "*",
			component: NotFound,
		},
	];
};

export default routes;
